import PropTypes from "prop-types";

const Card = ({ children, className = "", ...props }) => {
  return (
    <div
      className={`bg-white rounded-xl overflow-hidden ${className}`}
      style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
      {...props}
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Card;
